import ClearIcon from "@mui/icons-material/Clear";
import { Box, Button, CircularProgress } from "@mui/material";
import { useNavigate } from "react-router-dom";
import TaskIconButton from "../../../components/common/TaskIconButton";

/**
 * Action buttons for submitting data-checker tasks or creating NAT gateway.
 *
 * @param {Object} props
 * @param {function} props.onSubmit
 * @param {function} props.onCreateGateway
 * @param {boolean} props.natGatewayReady
 * @param {boolean} props.natGatewayLoading
 * @param {boolean} props.taskSubmitting
 * @returns {JSX.Element}
 */
const ActionButtons = ({ onSubmit, onCreateGateway, natGatewayReady, natGatewayLoading, taskSubmitting }) => {
  const navigate = useNavigate();

  return (
    <Box sx={{ display: "flex", gap: 1 }}>
      {natGatewayReady ? (
        <Button
          variant="outlined"
          color="primary"
          onClick={onSubmit}
          disabled={natGatewayLoading || taskSubmitting}
        >
          Create Data Checker Task
        </Button>
      ) : (
        <Button
          variant="outlined"
          color="secondary"
          onClick={onCreateGateway}
          disabled={natGatewayLoading}
          startIcon={natGatewayLoading && <CircularProgress size={20} color="inherit" />}
        >
          {natGatewayLoading ? "Creating Gateway..." : "Create NAT Gateway"}
        </Button>
      )}
      <TaskIconButton color="error" text="Cancel" icon={<ClearIcon />} onClick={() => navigate("/tasks")} />
    </Box>
  );
};

export default ActionButtons;
